export type Permission =
  | 'users.read'
  | 'users.write'
  | 'users.delete'
  | 'users.manage_roles'
  | 'content.read'
  | 'content.write'
  | 'content.delete'
  | 'content.moderate'
  | 'events.read'
  | 'events.write'
  | 'events.delete'
  | 'events.manage'
  | 'community.read'
  | 'community.write'
  | 'community.moderate'
  | 'reports.read'
  | 'reports.write'
  | 'admin.read'
  | 'admin.write'
  | 'admin.settings'
  | 'billing.read'
  | 'billing.write'
  | 'analytics.read'
  | 'analytics.export';

export type Role = 'user' | 'moderator' | 'admin' | 'super_admin';

const rolePermissions: Record<Role, Permission[]> = {
  user: [
    'users.read',
    'content.read',
    'content.write',
    'events.read',
    'community.read',
    'community.write',
    'reports.read',
  ],
  moderator: [
    'users.read',
    'content.read',
    'content.write',
    'content.delete',
    'content.moderate',
    'events.read',
    'events.write',
    'community.read',
    'community.write',
    'community.moderate',
    'reports.read',
  ],
  admin: [
    'users.read',
    'users.write',
    'users.delete',
    'users.manage_roles',
    'content.read',
    'content.write',
    'content.delete',
    'content.moderate',
    'events.read',
    'events.write',
    'events.delete',
    'events.manage',
    'community.read',
    'community.write',
    'community.moderate',
    'reports.read',
    'reports.write',
    'admin.read',
    'admin.write',
    'admin.settings',
    'billing.read',
    'billing.write',
    'analytics.read',
    'analytics.export',
  ],
  super_admin: [
    'users.read',
    'users.write',
    'users.delete',
    'users.manage_roles',
    'content.read',
    'content.write',
    'content.delete',
    'content.moderate',
    'events.read',
    'events.write',
    'events.delete',
    'events.manage',
    'community.read',
    'community.write',
    'community.moderate',
    'reports.read',
    'reports.write',
    'admin.read',
    'admin.write',
    'admin.settings',
    'billing.read',
    'billing.write',
    'analytics.read',
    'analytics.export',
  ],
};

export function hasPermission(role: Role, permission: Permission): boolean {
  return rolePermissions[role]?.includes(permission) ?? false;
}

export function hasAnyPermission(role: Role, permissions: Permission[]): boolean {
  return permissions.some((p) => hasPermission(role, p));
}

export function hasAllPermissions(role: Role, permissions: Permission[]): boolean {
  return permissions.every((p) => hasPermission(role, p));
}

export function canAccessRoute(role: Role, requiredRole?: Role): boolean {
  if (!requiredRole) return true;
  const roleHierarchy: Record<Role, number> = {
    user: 1,
    moderator: 2,
    admin: 3,
    super_admin: 4,
  };
  return roleHierarchy[role] >= roleHierarchy[requiredRole];
}
